import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUsers, FiDollarSign, FiTrendingUp, FiClock } = FiIcons;

const StatsCards = ({ clients }) => {
  const stats = [
    {
      title: 'Totale Clienti',
      value: clients.length,
      icon: FiUsers,
      color: 'blue'
    },
    {
      title: 'Valore Contratti',
      value: `€${clients.reduce((sum, client) => sum + client.contractValue, 0).toLocaleString()}`,
      icon: FiDollarSign,
      color: 'green'
    },
    {
      title: 'Commissioni Maturate',
      value: `€${clients.reduce((sum, client) => sum + (client.commission || 0), 0).toLocaleString()}`,
      icon: FiTrendingUp,
      color: 'emerald'
    },
    {
      title: 'In Attesa',
      value: clients.filter(c => c.status === 'nuovo_lead' || c.status === 'in_trattativa').length,
      icon: FiClock,
      color: 'orange'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-500 text-blue-600 bg-blue-50',
    green: 'bg-green-500 text-green-600 bg-green-50',
    emerald: 'bg-emerald-500 text-emerald-600 bg-emerald-50',
    orange: 'bg-orange-500 text-orange-600 bg-orange-50'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 mb-1">{stat.title}</p>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
            </div>
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colorClasses[stat.color].split(' ')[2]}`}>
              <SafeIcon 
                icon={stat.icon} 
                className={`text-xl ${colorClasses[stat.color].split(' ')[1]}`} 
              />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default StatsCards;